<div class="policy-cookies" id="policy-cookies">
  <img alt="cerrar-cookies" class="close" src="/cookies/closed.svg" (click)="acceptCookies()" />
  <h3 class="tittle">TRACSA utiliza cookies</h3>

  <p class="description">
    Al navegar en nuestro sitio, permites el uso de “cookies” en tu dispositivo, con las que podemos
    ofrecerte una mejor experiencia de navegación, así como analizar el uso del sitio. No utilizamos
    ningún tipo de información personal.
  </p>
  <button class="accetepd" (click)="acceptCookies()">Aceptar</button>
  <a href="/legales/politica-de-cookies">
    <button class="terms">Consultar política de cookies</button>
  </a>
</div>
